/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AccordionModule, ButtonModule, SharedModule } from '@dm/ang';
import { CoreModule } from '@dm/core';

import { TaskSModule } from '../../task-s/task-s.module';
import { TaskCenterService } from '../task-center.service';
import { TaskStrService } from '../task-str.service';
import { ProgressBarModule } from './progress-bar/progress-bar.module';
import { TaskPanelComponent } from './task-panel.component';

@NgModule({
    imports: [
        CommonModule,
        ButtonModule,
        AccordionModule,
        SharedModule,
        CoreModule,
        RouterModule,
        ProgressBarModule,
        TaskSModule,
    ],
    declarations: [
        TaskPanelComponent,
    ],
    providers: [
        TaskCenterService,
        TaskStrService,
    ],
    exports: [
        TaskPanelComponent,
    ],
})
export class TaskPanelModule { }
